import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { firstValueFrom } from 'rxjs';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import Swal from 'sweetalert2';
import { environment } from 'src/app/environments/environments';

@Component({
  selector: 'app-modal-maintenance-ot',
  templateUrl: './modal-maintenance-ot.component.html',
  styleUrls: ['./modal-maintenance-ot.component.css']
})
export class ModalMaintenanceOtComponent {
  requestForm: FormGroup;
  loadingFull: boolean = true;
  loading: any;
  id: string = '';
  action: string = '';

  
  spare_parts_validation: boolean = false;
  delivery_date: boolean = false;
  validation_comments: string | null = null;

  constructor(
    private fb: FormBuilder,
    public thisModalRef: MdbModalRef<ModalMaintenanceOtComponent> | null = null,
    private crudService: GenericCrudService<any>
  ) {
    this.requestForm = this.fb.group({
      spare_parts_validation: [null],
      delivery_date: [null],
      validation_comments: [null],
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      this.loadingFull = true;
    } catch (error) {
      console.log('[ngOnInit] error: ', error);
    } finally {
      this.loadingFull = false;
    }
  }

  closeModal() {
    this.thisModalRef?.close(true);
  }

  updateOTByMaintenance(): void {
      try {
        Swal.fire({
          title: '¿Está seguro de que desea actualizar la OT?',
          icon: 'warning',
          width: 800,
          customClass: {
            popup: 'custom-swal-popup'
          },
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
          cancelButtonText: 'Cancelar',
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: 'Procesando...',
              allowOutsideClick: false,
              showCancelButton: false,
              showCloseButton: false,
              showConfirmButton: false,
              willOpen: async () => {
                Swal.showLoading();
                const body = new FormData();
                body.append('action', 'UPDATE');
                body.append('table_name', 'WORK_ORDERS');
    
                body.append('id', this.id);
                body.append('spare_parts_validation', this.requestForm.get('spare_parts_validation')?.value == true ? '1' : '0');
                body.append('delivery_date', this.requestForm.get('delivery_date')?.value);
                body.append('validation_comments', this.requestForm.get('validation_comments')?.value);
                body.append('status', '2');
      
                const response: any = await firstValueFrom(
                  this.crudService.crud(body, environment.GenericCrudOperation)
                );
      
                if (response && response.status === 1) {
                //   const bodyMail = new FormData();
                //   bodyMail.append('id_binnacle', this.id);
                //   bodyMail.append('id_user', localStorage.getItem('IdUser') ?? '');
                //   await firstValueFrom(
                //     this.crudService.crud(bodyMail, environment.SendMailApproveOrReject)
                //   );
                  Swal.fire({
                    icon: 'success',
                    title: 'Se ha actualizado correctamente!',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.closeModal();
                }
              },
            });
          }
        });
  
      } catch (error) {
        console.error('Error: ', error);
      }
    }
}
